<template>
	<div class="digital-signature-wrapper">
		<div v-if="applicationStatusId === 1 && route().current('form.*')" class="digital-signature">
			<digital-signature v-model="context.model" />
		</div>
		<div v-else>
			<img v-if="context.model" :src="context.model" alt="Signature" class="digital-signature-image" />
			<em v-else>No Signature Present</em>
		</div>
	</div>
</template>
<script>
import DigitalSignature from '@/Component/DigitalSignature'
export default {
	components: { DigitalSignature },
	props: {
		context: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			//
		}
	},
	computed: {
		applicationStatusId () {
			return this.$store.getters.applicationStatusId
		}
	},
	watch: {
		//
	},
	methods: {
		//
	}
}
</script>
